export type AuthRequirements = {
  mfa: AuthRequirements.Mfa;
  sso: AuthRequirements.Sso;
};

export namespace AuthRequirements {
  export type SecondFactor = {
    factorId: string;
    uid?: string;
  };

  export type Mfa = {
    required: boolean;
    satisfied: boolean;
    secondFactor?: SecondFactor;
  };

  export type Sso = {
    required: boolean;
    satisfied: boolean;
    provider?: {
      type: 'saml';
      organizationId?: string;
      providerId?: string;
    };
  };

  export type MfaClaims = {
    signInSecondFactor?: string | undefined;
    secondFactorIdentifier?: string | undefined;
  };

  export const Mfa = (params: { required: boolean; claims: MfaClaims }): Mfa => {
    const secondFactor = params.claims.signInSecondFactor
      ? {
          factorId: params.claims.signInSecondFactor,
          ...(params.claims.secondFactorIdentifier ? { uid: params.claims.secondFactorIdentifier } : {}),
        }
      : undefined;

    return {
      required: params.required,
      satisfied: !!secondFactor,
      ...(secondFactor ? { secondFactor } : {}),
    };
  };

  export const Sso = (params: Sso): Sso => {
    return params;
  };

  export const IsMfaRequiredAndUnsatisfied = (requirements: Pick<AuthRequirements, 'mfa'>): boolean => {
    return requirements.mfa.required && !requirements.mfa.satisfied;
  };

  export const IsSsoRequiredAndUnsatisfied = (requirements: Pick<AuthRequirements, 'sso'>): boolean => {
    return requirements.sso.required && !requirements.sso.satisfied;
  };
}
